import React from "react";

const OLIVE = "#4B5137";
const CLAY = "#A65F42";
const LEATHER = "#76533B";

// Small editorial ornament placed INSIDE a section's background (placement/spacing unchanged).
function Sketch({ children, testid, w }) {
  return (
    <div className="w-full flex justify-center -mt-8 mb-10 sm:-mt-6 sm:mb-12" data-testid={testid} aria-hidden="true">
      <div className="max-w-full" style={{ width: w }}>{children}</div>
    </div>
  );
}

const c = { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", vectorEffect: "non-scaling-stroke" };

// 1. A simple survey baseline with a few station marks (non-pictorial).
export function RoadDivider() {
  return (
    <Sketch testid="divider-road" w={188}>
      <svg viewBox="0 0 200 22" width="100%" className="opacity-90">
        <line x1="18" y1="11" x2="182" y2="11" stroke={OLIVE} strokeWidth="1.1" {...c} />
        <line x1="100" y1="4" x2="100" y2="18" stroke={CLAY} strokeWidth="1.1" {...c} />
        <line x1="70" y1="6" x2="70" y2="16" stroke={OLIVE} strokeWidth="1" {...c} />
        <line x1="130" y1="6" x2="130" y2="16" stroke={OLIVE} strokeWidth="1" {...c} />
        <line x1="18" y1="8" x2="18" y2="14" stroke={LEATHER} strokeWidth="1" {...c} />
        <line x1="182" y1="8" x2="182" y2="14" stroke={LEATHER} strokeWidth="1" {...c} />
      </svg>
    </Sketch>
  );
}

// 2. A minimal drafting line motif: a measured baseline with a fine parallel guide (no objects).
export function RulerDivider() {
  return (
    <Sketch testid="divider-ruler" w={198}>
      <svg viewBox="0 0 200 26" width="100%" className="opacity-90">
        <line x1="16" y1="18" x2="184" y2="18" stroke={OLIVE} strokeWidth="1.1" {...c} />
        <line x1="44" y1="8" x2="156" y2="8" stroke={CLAY} strokeWidth="1" strokeDasharray="3 5" opacity="0.7" {...c} />
        <line x1="100" y1="18" x2="100" y2="5" stroke={CLAY} strokeWidth="1.1" {...c} />
        {[40, 56, 72, 88, 116, 132, 148, 164].map((x) => (
          <line key={x} x1={x} y1="18" x2={x} y2="13" stroke={OLIVE} strokeWidth="0.9" {...c} />
        ))}
        <line x1="16" y1="18" x2="16" y2="12" stroke={LEATHER} strokeWidth="1" {...c} />
        <line x1="184" y1="18" x2="184" y2="12" stroke={LEATHER} strokeWidth="1" {...c} />
      </svg>
    </Sketch>
  );
}

// 3. Dragoon Mountains ridgeline (unchanged, the only mountain motif).
export function RidgeDivider() {
  return (
    <Sketch testid="divider-ridge" w={228}>
      <svg viewBox="0 0 220 50" width="100%" className="opacity-90">
        <path d="M4 40 L34 24 L52 30 L78 12 L96 22 L120 6 L148 22 L170 13 L196 27 L216 22"
          stroke={OLIVE} strokeWidth="1.2" {...c} />
        <path d="M4 44 L34 32 L52 36 L78 24 L96 31 L120 19 L148 31 L170 25 L196 34 L216 30"
          stroke={CLAY} strokeWidth="1" opacity="0.5" {...c} />
        <circle cx="120" cy="6" r="1.8" fill={CLAY} stroke="none" />
      </svg>
    </Sketch>
  );
}

// 4. An understated, naturally irregular clump of grass (no arrow tips).
export function GrassDivider() {
  return (
    <Sketch testid="divider-grass" w={170}>
      <svg viewBox="0 0 160 96" width="100%" className="opacity-90">
        <path d="M70 92 C66 66 60 50 54 33" stroke={OLIVE} strokeWidth="1.1" {...c} />
        <path d="M78 92 C80 62 82 45 84 27" stroke={OLIVE} strokeWidth="1.2" {...c} />
        <path d="M86 92 C90 68 98 55 104 41" stroke={CLAY} strokeWidth="1" opacity="0.75" {...c} />
        <path d="M74 92 C72 70 70 58 69 47" stroke={OLIVE} strokeWidth="1" {...c} />
        <path d="M92 92 C97 73 104 65 111 56" stroke={OLIVE} strokeWidth="1.1" {...c} />
        <path d="M64 92 C61 78 56 70 50 62" stroke={OLIVE} strokeWidth="1" {...c} />
        <path d="M82 92 C83 76 84 68 85 61" stroke={LEATHER} strokeWidth="0.9" opacity="0.8" {...c} />
        <line x1="56" y1="92" x2="100" y2="92" stroke={LEATHER} strokeWidth="1" opacity="0.55" {...c} />
      </svg>
    </Sketch>
  );
}
